import { get, off, ref, update } from "firebase/database";
import { listenDatabaseValue as onValue } from "../utils/listenDatabaseValue";
import { getPathDatabaseByRole } from "./auth";
import { db } from "../lib/firebase";
import { LaunchError } from "../utils/errors";
import {
  buildNextSupportSessionsNode,
  canScheduleSupportSession,
  getSupportSessionsPath,
} from "../utils/supportSessions";

export const startListenerSupportSessions =
  ({ onUpdatedDataCallback = () => {}, onReferenceAvailable = () => {} }) =>
  async (dispatch) => {
    try {
      const { agencyID } = dispatch(getPathDatabaseByRole());

      if (!agencyID) {
        onUpdatedDataCallback(null);
        return false;
      }

      const path = getSupportSessionsPath({ agencyID });
      const dbRef = ref(db, path);

      onReferenceAvailable(dbRef);
      onValue(dbRef, (snapshot) => {
        onUpdatedDataCallback(snapshot.val() || null);
      });

      return true;
    } catch (error) {
      onUpdatedDataCallback(null);
      dispatch(
        LaunchError(error, false, [], {
          functionName: "startListenerSupportSessions",
        })
      );
      return false;
    }
  };

export const stopListenerSupportSessions =
  ({ listenerRef } = {}) =>
  async () => {
    if (!listenerRef) return;
    await off(listenerRef);
  };

export const startSaveSupportSession = () => async (dispatch) => {
  try {
    const { agencyID } = dispatch(getPathDatabaseByRole());

    if (!agencyID) {
      return { ok: false, reason: "missingAgencyID" };
    }

    const path = getSupportSessionsPath({ agencyID });
    const snapshot = await get(ref(db, path));
    const supportSessions = snapshot.val() || null;

    if (!canScheduleSupportSession({ supportSessions })) {
      return { ok: false, reason: "quotaReached" };
    }

    const nextSupportSessions = buildNextSupportSessionsNode({
      supportSessions,
    });

    if (!nextSupportSessions) {
      return { ok: false, reason: "quotaReached" };
    }

    await update(ref(db), {
      [path]: nextSupportSessions,
    });

    return { ok: true, supportSessions: nextSupportSessions };
  } catch (error) {
    dispatch(
      LaunchError(error, true, [], {
        functionName: "startSaveSupportSession",
      })
    );
    return { ok: false, reason: "error" };
  }
};
